import {useMemo} from 'react';

import {ItemSubType, ItemType, useCharacterItemSearchQuery} from '../../../../../generated/types';
import {isEquippableKind, isMagicRarity} from '../../model/equipment';
import type {PickCategory, StartingItemInfo} from '../../model/starting-equipment';

/** все предметы базы с видами для выбора «музыкальный инструмент по вашему выбору» */
export function useStartingItems() {
	const {data, loading} = useCharacterItemSearchQuery();

	const items = useMemo(
		(): StartingItemInfo[] =>
			(data?.items || []).map((item) => {
				const categories: PickCategory[] = [];
				if (item.subType?.includes(ItemSubType.Instrument)) categories.push('instrument');
				if (item.type === ItemType.GamingSet) categories.push('gamingSet');
				if (item.type === ItemType.ArtisansTools) categories.push('artisansTools');
				const equippable = isEquippableKind({
					type: item.type,
					subTypes: item.subType || [],
					isMagic: isMagicRarity(item.rarity),
				});
				return {id: item.id, title: item.title, categories, equippable};
			}),
		[data],
	);
	const titles = useMemo(() => new Map(items.map((item) => [item.id, item.title])), [items]);

	return {items, titles, loading};
}
